import React from 'react'
import {
  tresholdValues,
  tresholdTypes,
  unitTypes,
} from '@generators/tresholdConstants'

const boldStyle = { fontFamily: 'Inter-Bold', fontWeight: 700, margin: 0 }
const noMarginStyle = { margin: 0 }

export function tresholdForDisplay(type, value, Text) {
  const values = tresholdValues[type]
  const types = tresholdTypes[type]
  const unit = unitTypes[type]
  const selected = getTresholdValueIndex(type, value)

  return types.map((t, index) => {
    if (index === 0) {
      return (
        <Text
          key={`${t}-${type}`}
          style={(selected === index && boldStyle) || noMarginStyle}
        >
          {`${t} (menor ${type === 'imc' ? 'ou igual a' : 'que'} ${
            values[0]
          }${unit})\n`}
        </Text>
      )
    }
    if (index === types.length - 1) {
      return (
        <Text
          key={`${t}-${type}`}
          style={(selected === index && boldStyle) || noMarginStyle}
        >
          {`${t} (maior ${values.length === 1 ? 'ou igual a' : 'que'} ${
            values[values.length - 1]
          }${unit})\n`}
        </Text>
      )
    }
    return (
      <Text
        key={`${t}-${type}`}
        style={(selected === index && boldStyle) || noMarginStyle}
      >
        {`${t} (${values[index - 1]} - ${values[index]}${unit})\n`}
      </Text>
    )
  })
}

export function bloodPressureTresholdForDisplay(syst, diast, Text) {
  const types = tresholdTypes.bloodPressure
  const descriptions = [
    '< 120 x 80 mmHg',
    '120–129 x 80–84 mmHg',
    '130–139 x 85–89 mmHg',
    '≥ 140 x 90 mmHg',
  ]

  const selected = getTresholdForBloodPressureValueIndex(syst, diast)

  return types.map((type, index) => (
    <Text
      key={`${syst}-${diast}-${type}`}
      style={(selected === index && boldStyle) || noMarginStyle}
    >
      {`${type} (${descriptions[index]})\n`}
    </Text>
  ))
}

export function getBloodPressureTresholdValue(syst, diast) {
  const index = getTresholdForBloodPressureValueIndex(syst, diast)
  if (index == null) return null
  return tresholdTypes.bloodPressure[index]
}

export function getTresholdValue(type, value) {
  const tresholds = tresholdValues[type]
  const tresholdType = tresholdTypes[type]

  for (let i = 0; i < tresholds.length; i += 1) {
    if (
      (i === 0 && value < tresholds[i])
      || (type === 'imc' && value <= tresholds[i])
    ) {
      return tresholdType[i]
    }
    if (
      i === tresholds.length - 1
      && tresholds.length === 1
      && value >= tresholds[i]
    ) {
      return tresholdType[i + 1]
    }
    if (i === tresholds.length - 1 && value > tresholds[i]) {
      return tresholdType[i + 1]
    }
    if (value >= tresholds[i - 1] && value <= tresholds[i]) {
      return tresholdType[i]
    }
  }
  return null
}

export function getTresholdForBloodPressureValueIndex(syst, diast) {
  if (syst == null || diast == null) return null

  const s = Number(syst)
  const d = Number(diast)

  if (Number.isNaN(s) || Number.isNaN(d)) return null

  if (s < 120 && d < 80) return 0

  if (s < 130 && d < 85) return 1

  if (s < 140 && d < 90) return 2

  return 3
}

export function getTresholdValueIndex(type, value) {
  const tresholds = tresholdValues[type]
  // const tresholdType = tresholdTypes[type]

  for (let i = 0; i < tresholds.length; i += 1) {
    if (i === 0 && value < tresholds[i]) {
      return i
    }
    if (
      i === tresholds.length - 1
      && tresholds.length === 1
      && value >= tresholds[i]
    ) {
      return i + 1
    }
    if (i === tresholds.length - 1 && value > tresholds[i]) {
      return i + 1
    }
    if (value >= tresholds[i - 1] && value <= tresholds[i]) {
      return i
    }
  }
  return null
}
